import { Page } from "components";
import { useApp, useParameter, useService, useSession } from "contexts";
import { Combines } from "helpers";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthParamType, MessageType, SessionType, ShareParamType } from "types";
import { Enums, Helpers, Routes } from "utils";

export const Share = () => {
  // const navigate = useNavigate();

  // const { setFeedback, t } = useApp();
  // const { potluckService, userService } = useService();
  // const { user, login, isAuthenticated } = useSession();
  // const { token, params } = useParameter<ShareParamType>();

  // const navigateToHome = () => navigate(Routes.home);
  // const navigateToProfile = () => navigate(Routes.userdashboard);
  // const navigateToLogin = (payload: AuthParamType) =>
  //   navigate(Helpers.encodedUrl<AuthParamType>(Routes.login, payload));

  // const addToParticipant = async (potluckId: string, userId: string) => {
  //   const response = await potluckService.nfindById(potluckId);
  //   if (response) {
  //     // add the user to participant
  //     if (new Date(response.date) < new Date()) {
  //       setFeedbackAndRedirectHome(t.message.feedback.invite.is_expired);
  //     } else if (response.participants.includes(userId as any)) {
  //       setFeedbackAndRedirectHome(
  //         t.message.feedback.invite.already_participant
  //       );
  //     } else {
  //       response.participants.push(userId as any);
  //       potluckService.update(response); // update
  //     }
  //   }
  //   console.log(response);
  // };

  // const setSessionAndRedirect = ({
  //   _id,
  //   email,
  //   first_name,
  //   last_name,
  //   role,
  // }) => {
  //   // TODO : improve it
  //   login({
  //     id: _id,
  //     email: email,
  //     name: `${first_name} ${last_name}`,
  //     role: role,
  //   } as SessionType);
  //   // redirect to profile page
  //   setFeedbackAndRedirectProfile(
  //     t.message.feedback.invite.successfully_accepted
  //   );
  // };

  // const setFeedbackAndRedirectHome = (message: string) => {
  //   setFeedback({
  //     severity: Enums.EnumFeedback.Info,
  //     message,
  //   } as MessageType);
  //   // redirect to home page
  //   navigateToHome();
  // };

  // const setFeedbackAndRedirectProfile = (message: string) => {
  //   setFeedback({
  //     severity: Enums.EnumFeedback.Success,
  //     message,
  //   } as MessageType);
  //   // redirect to profile page
  //   navigateToProfile();
  // };

  // useEffect(() => {
  //   const runProcess = async () => {
  //     if (!token) {
  //       // If token is missing, redirect to error or home
  //       setFeedbackAndRedirectHome(t.message.feedback.invite.missing_token);
  //       return;
  //     }

  //     if (params) {
  //       // the user is authenticated
  //       if (isAuthenticated) {
  //         // test conditions to determine if the invite is for the user
  //         if (
  //           (!params.email && !params.userId) || // the invite does not contain an email or user id
  //           (params.userId && params.userId === user.id) || // or the user is authenticated and the user id matches
  //           (params.email && params.email === user.email) // or the user is authenticated and the email matches
  //         ) {
  //           addToParticipant(params.potluckId, user.id);
  //           setFeedbackAndRedirectProfile(
  //             t.message.feedback.invite.successfully_accepted
  //           );
  //         } else {
  //           // the invite is not for the user, redirect
  //           setFeedbackAndRedirectHome(t.message.feedback.invite.not_invited);
  //         }
  //       } else {
  //         // the user is not authenticated
  //         if (!params.email && !params.userId) {
  //           // the invite is public and anyone can add it
  //           // prompt account manager (either log in, sign up, or guest)
  //           // once session is set
  //           // add the user to participant
  //           // redirect it to profile page
  //           navigateToLogin({
  //             redirect: Helpers.encodedUrl(Routes.share, { token }),
  //           } as AuthParamType);
  //         } else if (params.userId || params.email) {
  //           // the user has an account
  //           const response = await userService.findByIdOrEmail(
  //             params.userId,
  //             params.email
  //           ); // look up the user account
  //           if (response) {
  //             // add the user to participant
  //             addToParticipant(params.potluckId, response._id);

  //             if (response.role === "guest") {
  //               // if the user is a guest, log them in
  //               setSessionAndRedirect(response);
  //             } else {
  //               // if the user is not a guest, prompt them to log in
  //               navigateToLogin({
  //                 email: response.email,
  //                 redirect: Helpers.encodedUrl(Routes.share, { token }),
  //               } as AuthParamType);
  //             }
  //           } else {
  //             setFeedbackAndRedirectHome(t.message.feedback.not_found);
  //           }
  //         }
  //       }
  //     }
  //   };

  //   runProcess();
  // }, [navigate]);

  return <Page.Loader />;
};
